import { render, staticRenderFns } from "./CallGroupFilter.vue?vue&type=template&id=2b8b1150&"
import script from "./CallGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./CallGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports